import { render, staticRenderFns } from "./menuItemWithSubmenu.vue?vue&type=template&id=32f434a9&scoped=true&"
import script from "./menuItemWithSubmenu.vue?vue&type=script&lang=js&"
export * from "./menuItemWithSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./menuItemWithSubmenu.vue?vue&type=style&index=0&id=32f434a9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f434a9",
  null
  
)

export default component.exports